import CustomTransferListWithoutActionButtons from 'Components/CustomTransferListWithoutActionButtons'
import { useGetAllowedClientsQuery } from 'Services/ServiceProviderManagement/Features/AllowedClient/allowedClientApi'
import { Box, ListItemText, Typography } from '@mui/material'
import { t } from 'ttag'

interface SPMAllowedApiClientsProps {
  selectedReadClients: string[]
  selectedWriteClients: string[]
  setSelectedReadClients: (selectedReadClients: string[]) => void
  setSelectedWriteClients: (selectedWriteClients: string[]) => void
}

export default function SPMAllowedApiClients({
  selectedReadClients,
  selectedWriteClients,
  setSelectedReadClients,
  setSelectedWriteClients
}: Readonly<SPMAllowedApiClientsProps>) {
  const {
    data: { allowed_clients: allowedClients = [] } = { allowed_clients: [] },
    isLoading: isAllowedClientsLoading
  } = useGetAllowedClientsQuery({
    exclude_manager_client: true
  })

  const renderItemContent = (clientId: string) => {
    const allowedClient = allowedClients.find(client => client === clientId)
    const labelId = `transfer-list-item-${clientId}-label`
    return <ListItemText id={labelId} primary={allowedClient} />
  }

  const handleReadClientsChange = (selectedItems: string[]) => {
    setSelectedReadClients(selectedItems)
  }

  const handleWriteClientsChange = (selectedItems: string[]) => {
    setSelectedWriteClients(selectedItems)
  }

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2
      }}
    >
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client read permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedClients}
          rightItems={selectedReadClients}
          renderItemContent={renderItemContent}
          optionsLoading={isAllowedClientsLoading}
          handleItemsChange={selectedItems => handleReadClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client write permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedClients}
          rightItems={selectedWriteClients}
          renderItemContent={renderItemContent}
          optionsLoading={isAllowedClientsLoading}
          handleItemsChange={selectedItems => handleWriteClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
    </Box>
  )
}
